import { Injectable } from "@angular/core";
import { FormGroup, FormBuilder } from '@angular/forms';
import { AppClientContext } from "src/app-client/_appCommon/base/AppClientContext";
import { ControllerBase } from '../../app/_appCommon/base/ControllerBase';

@Injectable()
export abstract class FormTools extends ControllerBase
{
  public stepFormGroup: FormGroup;

  public booleanOptions = [
    { value: true, display: "Si" },
    { value: false, display: "No" }
    
  ];

  public booleanDescriptionOptions = [
    { value: false, display: "Mantener" },
    { value: true, display: "Modificar" },
  ];

  public selectNumberOptions = [];
  public selectNumberTenthsOfMilimeterOptions = [];
  public selectNumberTenthsOfMilimeterUntil1Options = [];

  constructor(protected numberOptions: number = 10, protected formBuilder: FormBuilder)
  {
    super();

    this.selectNumberOptions = [...Array(this.numberOptions)].map((_, i) => i + 1);
    this.selectNumberTenthsOfMilimeterOptions = [.1, .2, .3, .4, .5];
    this.selectNumberTenthsOfMilimeterUntil1Options = [...Array(this.numberOptions)].map((_, i) => (i + 1)/10);
  }

  ngOnInit()
  {
    this.stepFormGroup = this.formBuilder.group({
      id: [0, null]
    });
  }

  public get GetPrescriptionId(): number
  {
    return AppClientContext.Instance.setup.prescriptionId;
  }

  public get GetSetupId(): number
  {
    return AppClientContext.Instance.setup.id;
  }

  public setCurrentSetupStep(step:any){
    AppClientContext.Instance.setup.currentStep = step;
  }

  public get GetCaseId(): number
  {
    return AppClientContext.Instance.case.id;
  }

  public getControl(form:FormGroup, controlName: string): any
  {
    return form.get(controlName).value;
  }

  public resetFormControl(form:FormGroup, controlName: string, value: any = null): void
  {
    if(controlName!='')
    {
      if (value)
      {
        form.controls[controlName].setValue(value);
      }
      else
      {
        form.controls[controlName].reset();
      }

      form.controls[controlName].setErrors(null);
    }
  }

  public onSetPieces(event: string[], form:FormGroup, controlName: string): void
  {
    form.controls[controlName].setValue(event);
  }

  public onCheckForm(form: any): void
  {
  }
}
